import ru from "./translations/ru";
import pt from "./translations/pt";
import en from "./translations/en";
import ITranslation from "../interface/translation";

/* Do not delete "en" because this is a value for Global.DEFAULT_LANGUAGE */

const Translations: ITranslation[] = [en, pt, ru];

export default Translations;